module.exports = __webpack_public_path__ + "static/team-841850649ef54d4e9a6f5024ced9874c.png";